module.exports = (__webpack_require__(2))("./template/css/default.css");


//////////////////
// WEBPACK FOOTER
// delegated ./template/css/default.css from dll-reference base
// module id = 144
// module chunks = 22